import React from 'react'
import { useIsRecurly } from 'sb-hooks'
import { modalVisibility, openModal } from 'sb-modal'

import SkipAMonthModalView from './SkipAMonthModalView/SkipAMonthModalView'

import useSkipAMonthModalVindicia from './util/useSkipAMonthModalVindicia'
import useSkipAMonthModalRecurly from './util/useSkipAMonthModalRecurly'
import type { UseSkipAMonthModalProps } from './util/useSkipAMonthModalBase'


const SkipAMonthModalVindicia: React.FunctionComponent<UseSkipAMonthModalProps> = (props) => {
  const {
    form, products, isProductsFetching, skipOptions, firstName,
    isUnsubscribeFlow, onConfirm, onContinue, onClose,
  } = useSkipAMonthModalVindicia(props)

  return (
    <SkipAMonthModalView
      form={form}
      products={products}
      isProductsFetching={isProductsFetching}
      skipOptions={skipOptions}
      firstName={firstName}
      isUnsubscribeFlow={isUnsubscribeFlow}
      onConfirm={onConfirm}
      onContinue={onContinue}
      onClose={onClose}
    />
  )
}


const SkipAMonthModalRecurly: React.FunctionComponent<UseSkipAMonthModalProps> = (props) => {
  const {
    form, products, isProductsFetching, skipOptions, firstName,
    isUnsubscribeFlow, onConfirm, onContinue, onClose,
  } = useSkipAMonthModalRecurly(props)

  return (
    <SkipAMonthModalView
      form={form}
      products={products}
      isProductsFetching={isProductsFetching}
      skipOptions={skipOptions}
      firstName={firstName}
      isUnsubscribeFlow={isUnsubscribeFlow}
      onConfirm={onConfirm}
      onContinue={onContinue}
      onClose={onClose}
    />
  )
}


const SkipAMonthModal: React.FunctionComponent<UseSkipAMonthModalProps> = (props) => {
  const isRecurly = useIsRecurly()

  return React.createElement(
    isRecurly ? SkipAMonthModalRecurly : SkipAMonthModalVindicia,
    props
  )
}


export const openSkipAMonthModal = (props: SkipAMonthModal.ModalProps) => {
  openModal('skipAMonth', props)
}


export default modalVisibility('skipAMonth', SkipAMonthModal)
